module.exports = __webpack_public_path__ + "assets/img/aiwriter-func3.2e6b12e5.png";